import React from "react";
import {
  Box,
  Typography,
  Paper,
  Avatar,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import "../../styles/PassengerInfoTable.scss";
import { formatDate } from "../../Style";

const PassengerTable = ({ form2Value }) => {
  // Prepare passenger data for table
  const preparePassengerData = () => {
    const passengers = [];

    // Add adults (now using family_members filtered by age)
    if (form2Value?.family_members?.filter(member => member.age >= 12).length > 0) {
      form2Value.family_members
        .filter(member => member.age >= 12)
        .forEach((adult, index) => {
          passengers.push({
            id: `adult-${index}`,
            type: "Adult",
            firstName: adult?.first_name || "-",
            lastName: adult?.last_name || "-",
            dob: formatDate(adult?.dob) || "-",
            mobile: `+${adult?.country_code || ""}-${adult?.phone || ""}`,
            gender: adult?.gender_type || "-",
            document:
              adult?.aadhar_number !== ""
                ? `Aadhar: ${adult?.aadhar_number || "-"}`
                : `Passport: ${adult?.passport_number || "-"}`,
            nationality: adult?.nationality || "-",
          });
        });
    }

    // Add children (age 2-12)
    if (form2Value?.family_members?.filter(member => member.age >= 2 && member.age < 12).length > 0) {
      form2Value.family_members
        .filter(member => member.age >= 2 && member.age < 12)
        .forEach((child, index) => {
          passengers.push({
            id: `child-${index}`,
            type: "Child",
            firstName: child?.first_name || "-",
            lastName: child?.last_name || "-",
            dob: formatDate(child?.dob) || "-",
            mobile: `+${child?.country_code || ""}-${child?.phone || ""}`,
            gender: child?.gender_type || "-",
            document:
              child?.aadhar_number !== ""
                ? `Aadhar: ${child?.aadhar_number || "-"}`
                : `Passport: ${child?.passport_number || "-"}`,
            nationality: child?.nationality || "-",
          });
        });
    }

    // Add infants (age < 2)
    if (form2Value?.family_members?.filter(member => member.age < 2).length > 0) {
      form2Value.family_members
        .filter(member => member.age < 2)
        .forEach((infant, index) => {
          passengers.push({
            id: `infant-${index}`,
            type: "Infant",
            firstName: infant?.first_name || "-",
            lastName: infant?.last_name || "-",
            dob: formatDate(infant?.dob) || "-",
            mobile: `+${infant?.country_code || ""}-${infant?.phone || ""}`,
            gender: infant?.gender_type || "-",
            document:
              infant?.aadhar_number !== ""
                ? `Aadhar: ${infant?.aadhar_number || "-"}`
                : `Passport: ${infant?.passport_number || "-"}`,
            nationality: infant?.nationality || "-",
          });
        });
    }

    return passengers;
  };

  const passengerData = preparePassengerData();

  return (
    <Paper elevation={4} className="passenger-info-paper">
      <Box className="passenger-info-header">
        <Avatar className="passenger-info-avatar">
          <GroupIcon className="passenger-info-icon" />
        </Avatar>
        <Typography variant="h6" className="passenger-info-title">
          Passenger Information
        </Typography>
      </Box>

      <Divider className="passenger-info-divider" />

      {passengerData.length > 0 ? (
        <TableContainer className="passenger-table-container">
          <Table
            className="passenger-table"
            aria-label="passenger information table"
          >
            <TableHead>
              <TableRow className="passenger-table-header">
                <TableCell className="passenger-table-cell-header">
                  Type
                </TableCell>
                <TableCell className="passenger-table-cell-header">
                  First Name
                </TableCell>
                <TableCell className="passenger-table-cell-header">
                  Last Name
                </TableCell>
                <TableCell className="passenger-table-cell-header">
                  DOB
                </TableCell>
                <TableCell className="passenger-table-cell-header">
                  Mobile
                </TableCell>
                <TableCell className="passenger-table-cell-header">
                  Gender
                </TableCell>
                <TableCell className="passenger-table-cell-header">
                  Document
                </TableCell>
                <TableCell className="passenger-table-cell-header">
                  Nationality
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {passengerData.map((passenger, index) => (
                <TableRow
                  key={passenger.id}
                  className={`passenger-table-row ${
                    index % 2 === 0
                      ? "passenger-table-row-even"
                      : "passenger-table-row-odd"
                  }`}
                >
                  <TableCell
                    className={`passenger-table-cell passenger-type-${passenger.type.toLowerCase()}`}
                  >
                    <span className="passenger-type-badge">
                      {passenger.type}
                    </span>
                  </TableCell>
                  <TableCell className="passenger-table-cell">
                    {passenger.firstName}
                  </TableCell>
                  <TableCell className="passenger-table-cell">
                    {passenger.lastName}
                  </TableCell>
                  <TableCell className="passenger-table-cell">
                    {passenger.dob}
                  </TableCell>
                  <TableCell className="passenger-table-cell">
                    {passenger.mobile}
                  </TableCell>
                  <TableCell className="passenger-table-cell">
                    {passenger.gender}
                  </TableCell>
                  <TableCell className="passenger-table-cell">
                    {passenger.document}
                  </TableCell>
                  <TableCell className="passenger-table-cell">
                    {passenger.nationality}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Box className="no-passenger-data">
          <Typography variant="body1" className="no-data-text">
            No passenger information available.
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default PassengerTable;